import styled from "styled-components";

import { colors, darkModeColors } from "../../../../consts";
import { device } from "../../../../services";

import WrapperContainer from "../../../Containers/WrapperContainer";
import { TableWrapper } from "../../../Table/styled";

export const ImportedRecordsTableWrapper = styled(WrapperContainer)`
  max-height: calc(44px + 64px * 4);
  height: fill-available;
  overflow-y: auto;
  height: 30vh;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px 6px ${colors.RAISIN_50};
    border: 2px solid ${darkModeColors.WHITE_RAISIN_100};
  }

  ::-webkit-scrollbar-track-piece {
    margin-block: 16px;
  }

  @media screen and (max-height: 800px) {
    height: 22vh;
  }

  @media screen and ${device.mobile} {
    height: unset;
    max-height: unset;
    overflow-y: unset;
  }

  ${TableWrapper} {
    border: 1px solid ${colors.RAISIN_40};

    overflow-y: hidden;

    @media screen and ${device.mobile} {
      overflow-y: unset;
    }
  }
`;
